import React, { useState, useEffect } from 'react';
import axiosInstance from '../../Services/axiosCommon';

const UseInspectorDD = (url,search) => {
    const [data, setDataInspector] = useState([]);

    async function getData() {
        axiosInstance.get(url,{params:{search:search}}).then(res => {
            // console.log('daataa',res.data?.data);
            let data = res.data;
            console.log(data,'dddd');
            let tempData = [];
            data.forEach((item) => {
                let tempObject = { value: item.value, label: item.label };
                tempData.push(tempObject);
            });
            res.data && setDataInspector(tempData);
        }).catch(err => {
            console.log(err, "err");
        })
    }
    //     try {
    //       const res = await axiosInstance.get(url);
    //     } catch (error) {
    //       console.log(error);
    //     }
    //   }
    useEffect(() => {
        getData();
    }, [url,search]);

    return { data , setDataInspector };
};

export default UseInspectorDD